import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center text-sm whitespace-nowrap overflow-x-auto">
      <ol className="flex items-center gap-1.5">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            )}
            {index === items.length - 1 ? (
              <span className="text-foreground-600 font-medium" aria-current="page">
                {item.label}
              </span>
            ) : (
              <Link
                to={item.href || '/'}
                className="text-foreground-400 hover:text-primary-500 transition-colors"
              >
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}